<template>
  <v-col
    v-if="visible"
    :id="`${def.id}-form-prop`"
    cols="12"
    :md="prsSize()"
    :sm="prsSize() > 6 ? 12 : 6"
    :class="cssClass"

    style="padding: 0 8px"
  >
    <div v-if="!readonly">
      <span v-if="def.lookup">
        <AbrFormPropLookUp
          :ref="def.name"
          :def="def"
          :model="Model"
          :readonly="readonly"
          :required="required"
          :error-messages="errorMessages"
          :clearable="!readonly"
          v-on="inputEvents"
        />
      </span>
      <span v-else>
        <AbrFormPropField
          :ref="def.name"
          :def="def"
          :model="Model"
          :required="required"
          :error-messages="errorMessages"
          v-on="inputEvents"
        />
      </span>
    </div>
    <div v-else>
      <AbrFormPropLookUp
        v-if="def.lookup"
        :def="def"
        :model="Model"
        :readonly="readonly"
      />
      <AbrFormPropReadOnly
        v-else
        :def="def"
        :model="Model"
        :readonly="readonly"
      />
    </div>
  </v-col>
</template>

<script>
import AbrFormPropField from "@/components/form/AbrFormPropField";
import AbrFormPropLookUp from "@/components/form/AbrFormPropLookUp";
import AbrFormPropReadOnly from "@/components/form/AbrFormPropReadOnly";
import AbrValidate from "../../mixins/AbrValidate";
import AbrEventsOff from "@/mixins/AbrEventsOff";
import  { isArraysSame } from '@/utils/array'

export default {
  name: "AbrFormProp",
  components: {
    AbrFormPropField,
    AbrFormPropLookUp,
    AbrFormPropReadOnly,
  },
  mixins: [AbrValidate, AbrEventsOff],
  props: ["def", "model", "cols", "modal"],
  data: (vm) => ({
    inputEvents: {},
    readonly: undefined,
    rules: undefined,
    errorMessages: [],
    required: false,
    valid: true,
    visible: true,
    value: undefined,
    Model: vm.model,
    cssClass: "py-1"
    
  }),
  
  async created() { 
    // console.log('AbrFormProp ' , this.def.name , ' cssClass :>> ' , this.def.cssClass);
    if(this.def.cssClass){
      this.cssClass = "py-1 " + this.def.cssClass;
    }else{
      this.cssClass = "py-1";
    }
    this.$eventBus.$on('changeModelInGrid' , (newModel , name) => {
      if(this.Model?.__proxy__?.dirty) {
        this.$set(this.Model.__proxy__.dirty, name, true)
        this.$set(this.Model, name, newModel)
      } 
    })    
  
    this.$eventBus.$on('girdModelIsDirty' , (newModel , name) => {
      if(this.Model?.__proxy__?.dirty) this.$set(this.Model.__proxy__.dirty, name, true)
    })

    this.$eventBus.$on('changeModelFileData',(newModel , name)=>{
      if(this.Model?.__proxy__?.dirty) this.$set(this.Model.__proxy__.dirty, name, true)
    })    
  
    this.$eventBus.$on('coverListItemChanged',(newModel , name)=>{
      if(this.Model?.__proxy__?.dirty) this.$set(this.Model.__proxy__.dirty, name, true)
    })
    this.checkReadOnly();

    this.def.eventHandlers &&
      this.$nextTick(
        () =>
          (this.inputEvents = this.$processEvent(
            this.def.eventHandlers,
            this.def.id,
            this
          ))
      );
    this.$nextTick(() => this.$eventBus.$emit(`${this.def.id}-onLoad`));
    const propValue =
      this.def.name in this.model ? this.model[this.def.name] : undefined;
    this.$set(this.model, this.def.name, propValue);
    this.rules =
      this.def.validations &&
      this.def.validations.filter((v) => v.fn || v.enabledCondition);

    this.$watch(
      `Model`,
      async (newModel) => {
        if(newModel){
          await this.checkVisibility()
          await this.checkRequired();
          await this.checkValidation(newModel[this.def.name])
          await this.checkReadOnly();
          this.defineLabel()
        }
      },
      { deep: true, immediate: true }
    );
    this.$watch(
      'def.cssClass',
      (nv)=>{        
        if(nv){
          this.cssClass = "py-1 " + nv;
        }else{
          this.cssClass = "py-1";
        }        
      }
    )

    this.$watch(
      `Model.${this.def.name}`,
      async (nv)=>{
        
        await this.checkDirty(nv)
        
      }, {deep: true ,  immediate: false}
    )

    if (this.$formMode === "fmCreate") {
      this.def.default &&
        this.$nextTick(async () => {
          const value =
            this.def.default?.$eval && (await this.$eval(this.def.default));
          if (!value || this.Model[this.def.name]) return;
          this.$set(this.Model, this.def.name, value);
        });
    }
  },

  beforeDestroy() {
    this.$eventBus.$off(`${this.def.id}-onLoad`);
    let p = this.$parent;
    let pageId;
    while (p) {
      if (p.def?.kind === "TFormPage") {
        pageId = p.def.id;
      }
      if (typeof p.unregister == "function") {
        p.unregister(this, pageId);
      }
      p = p.$parent;
    }
  },
  async mounted() {
    
    // const pageId = this.def.panel.section.page.id;
    // this.$eventBus.$emit(`${this.def.panel.section.page.form.id}-RegisterInputs`, pageId);
    let p = this.$parent;
    let pageId;
    while (p) {
      if (p.def?.kind === "TFormPage") {
        pageId = p.def.id;
      }
      if (typeof p.register == "function" && p.def?.kind === "TForm") {
        p.register(this, pageId);
        break;
      }
      p = p.$parent;
    }
  },

  methods: {
    async checkVisibility(){
      this.visible = await this.$checkVisibility(this.def);
    },
    async checkRequired() {
      this.required =
        this.def.required ||
        (this.rules &&
          (
            await Promise.all(
              this.rules
                .filter(
                  (r) =>
                    r.preset &&
                    r.preset.name === "ECore.Def.DefEnums.prvRequired" &&
                    r.required
                )
                .map(async (r) => await this.$eval(r.required))
            )
          ).some((r) => r));

      this.valid =  !this.required    
    },
    async checkReadOnly() {

      const formMode = this.$formMode;
      if (this.def.kind === "TSearchProp") {
        this.readonly = false;
      }else if(formMode === "fmView" || formMode === "fmDelete"){
        this.readonly = true; 

      }else{
        const def = this.def.readOnly ??
            this.def.panel?.readOnly ??
            this.def.panel?.section?.readOnly ??
            this.def.panel?.section?.page?.readOnly


        if(!def) return
        this.readonly = def?.readOnlyExpr
          ? await this.$eval(def.readOnlyExpr)
          :def[formMode]
      }

    },
    async checkValidation(newValue){
      if (this.def.checkValidation || this.def.checkValidation === undefined){
          newValue || newValue === 0 ? await this.validate() : (this.valid = false);
      }

    },
    async checkDirty(newValue){
      if (this.Model.__proxy__ && !Array.isArray(this.Model.__proxy__.originalValues[this.def.name])) {
          this.Model.__proxy__.dirty[this.def.name] =
          newValue !== this.Model.__proxy__.originalValues[this.def.name];
        }else if(this.Model.__proxy__ && Array.isArray(this.Model.__proxy__.originalValues[this.def.name])){
          const isSameModel = await isArraysSame(newValue ,this.Model.__proxy__.originalValues[this.def.name])
          const isDirty =  !isSameModel

          this.Model.__proxy__.dirty[this.def.name] = isDirty
        }


    },
    async defineLabel(){
      if (this.def.labelExpr) {
          const label = await this.$eval(this.def.labelExpr);
          if (!label) return;
          this.def.label.resourceKey = await this.$eval(this.def.labelExpr);
        }
    },
    prsSize() {
      // let cols = this.modal ? 6 : 4;
      let cols =
        (this.Model.RiskCodeDefID && 4) || (this.modal && 6) || this.cols || 4;
      if (!this.def.displayWidth) return cols;
      switch (this.def.displayWidth.name.split(".").pop()) {
        case "prsSmall":
          cols = 4;
          break;
        case "prsMedium":
          cols = 6;
          break;
        case "prsLarge":
          cols = 8;
          break;
        case "prsXLarge":
          cols = 12;
          break;
        default:
          cols = 4;
          break;
      }
      return cols;
    },
  },
};
</script>
<style>
.v-text-field__slot label,
.v-auto-complete__slot label,
.v-select__slot label,
.v-list-item__title {
  font-size: 14px !important;
}
.v-input__slot {
  border-color: #aab2bd !important;
}
.v-text-field--outlined fieldset {
  border-color: #aab2bd !important;
}
red--text {
  color:red;
}
blue--text {
  color:blue;
}
</style>
